module.exports = __webpack_public_path__ + "img/owl-pink-front.37be0f4c.png";